/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DataRest, HelpResponse, HelpSearchResponse, RowResponse, RowsResponse, SectionResponse, SectionsResponse, SubSectionResponse, SubSectionsResponse } from '../model/api/data-rest';
import { environment } from 'src/environments/environment';
import { resources } from './api';
import { RowDataDb, SectionDataDb, SubSectionDataDb } from '../model/help';


@Injectable({
    providedIn: 'root'
})
export class HelpService {

    constructor(
        private http: HttpClient,
    ) {
    }

    encClientId(): string {
        const client = environment.clientId + ':' + environment.clientSecret;
        return btoa(client);
    }

    getHelp(language: string, appid: string): Observable<HelpResponse> {
        const params = new HttpParams()
            .append('language', language)
            .append('appid', appid);
        return this.http.get<HelpResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('help')}`, { params });
    }

    getHelpAll(language: string): Observable<HelpResponse> {
        const params = new HttpParams()
            .append('language', language);
        return this.http.get<HelpResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('helpall')}`, { params });
    }


    getHelpGuest(language: string, appid: string): Observable<HelpResponse> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                Authorization: 'Basic ' + this.encClientId()
            }),
            params: new HttpParams()
            .append('language', language)
            .append('appid', appid)
        };
        return this.http.get<HelpResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('helpguest')}${resources.get('help')}`, httpOptions);
    }

    getHelpGuestSearch(language: string, filter: string, appid: string): Observable<HelpSearchResponse> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                Authorization: 'Basic ' + this.encClientId()
            }),
            params: new HttpParams()
            .append('language', language)
            .append('filter', filter)
            .append('appid', appid)
        };
        return this.http.get<HelpSearchResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('helpguest')}${resources.get('helpsearch')}`, httpOptions);
    }

    getHelpSearch(language: string, filter: string, appid: string): Observable<HelpSearchResponse> {
        const params = new HttpParams()
            .append('language', language)
            .append('filter', filter)
            .append('appid', appid);
        return this.http.get<HelpSearchResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('helpsearch')}`, { params });
    }

    getHelpSectionAll(): Observable<SectionsResponse> {
        const params = new HttpParams();
        return this.http.get<SectionsResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('sections')}`);
    }
    getHelpSections(): Observable<SectionsResponse> {
        const params = new HttpParams();
        return this.http.get<SectionsResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('sections')}`);
    }
    getHelpSection(sectionId: number): Observable<SectionResponse> {
        const params = new HttpParams();
        return this.http.get<SectionResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('section')}/${sectionId}`);
    }
    addHelpSection(section: SectionDataDb): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('section')}`, section);
    }
    editHelpSection(section: SectionDataDb): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('section')}/${section.Id}`, section);
    }
    deleteHelpSection(sectionId: number): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('section')}/${sectionId}`);
    }
    getHelpSubSections(sectionId: number): Observable<SubSectionsResponse> {
        const params = new HttpParams();
        return this.http.get<SubSectionsResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsections')}/${sectionId}`);
    }
    getHelpSubSection(subsectionId: number): Observable<SubSectionResponse> {
        const params = new HttpParams();
        return this.http.get<SubSectionResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsection')}/${subsectionId}`);
    }
    addHelpSubSection(subsection: SubSectionDataDb): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsection')}`, subsection);
    }
    editHelpSubSection(subsection: SubSectionDataDb): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsection')}/${subsection.Id}`, subsection);
    }
    deleteHelpSubSection(subsectionId: number): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsection')}/${subsectionId}`);
    }
    getHelpRows(subsectionId: number): Observable<RowsResponse> {
        const params = new HttpParams();
        return this.http.get<RowsResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsectionrows')}/${subsectionId}`);
    }
    getHelpRow(rowId: number): Observable<RowResponse> {
        const params = new HttpParams();
        return this.http.get<RowResponse>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsectionrow')}/${rowId}`);
    }
    addHelpRow(row: RowDataDb): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsectionrow')}`, row);
    }
    editHelpRow(row: RowDataDb): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsectionrow')}/${row.Id}`, row);
    }
    deleteHelpRow(rowId: number): Observable<DataRest> {
        const params = new HttpParams();
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('v1')}${resources.get('help')}${resources.get('subsectionrow')}/${rowId}`);
    }
}
